import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPdf48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="pdf">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23C1 21.3431 2.34315 20 4 20H35C36.6569 20 38 21.3431 38 23V33C38 34.6569 36.6569 36 35 36H4C2.34315 36 1 34.6569 1 33V23ZM4 22C3.44772 22 3 22.4477 3 23V33C3 33.5523 3.44772 34 4 34H35C35.5523 34 36 33.5523 36 33V23C36 22.4477 35.5523 22 35 22H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C9 2.23858 11.2386 0 14 0H32C32.2589 0 32.5078 0.100428 32.6941 0.280156L46.6941 13.7802C46.8896 13.9686 47 14.2285 47 14.5V43C47 45.7614 44.7614 48 42 48H14C11.2386 48 9 45.7614 9 43V35H11V43C11 44.6569 12.3431 46 14 46H42C43.6569 46 45 44.6569 45 43V15.5H34C32.3431 15.5 31 14.1569 31 12.5V2H14C12.3431 2 11 3.34315 11 5V21H9V5ZM33 3.35347L43.5223 13.5H34C33.4477 13.5 33 13.0523 33 12.5V3.35347Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11.007 23.6C11.751 23.6 12.395 23.724 12.939 23.972C13.491 24.22 13.915 24.572 14.211 25.028C14.507 25.484 14.655 26.024 14.655 26.648C14.655 27.264 14.507 27.804 14.211 28.268C13.915 28.724 13.491 29.076 12.939 29.324C12.395 29.564 11.751 29.684 11.007 29.684H9.315V32H7.371V23.6H11.007ZM10.899 28.1C11.483 28.1 11.927 27.976 12.231 27.728C12.535 27.472 12.687 27.112 12.687 26.648C12.687 26.176 12.535 25.816 12.231 25.568C11.927 25.312 11.483 25.184 10.899 25.184H9.315V28.1H10.899ZM16.0429 23.6H19.8589C20.7709 23.6 21.5749 23.776 22.2709 24.128C22.9749 24.472 23.5189 24.96 23.9029 25.592C24.2949 26.224 24.4909 26.96 24.4909 27.8C24.4909 28.64 24.2949 29.376 23.9029 30.008C23.5189 30.64 22.9749 31.132 22.2709 31.484C21.5749 31.828 20.7709 32 19.8589 32H16.0429V23.6ZM19.7629 30.404C20.6029 30.404 21.2709 30.172 21.7669 29.708C22.2709 29.236 22.5229 28.6 22.5229 27.8C22.5229 27 22.2709 26.368 21.7669 25.904C21.2709 25.432 20.6029 25.196 19.7629 25.196H17.9869V30.404H19.7629ZM27.9009 25.16V27.38H31.7889V28.94H27.9009V32H25.9569V23.6H32.3049V25.16H27.9009Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
